module.exports = fox._r("images/heart.svg", __webpack_public_path__ + "_/_/_/root/images/heart.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/heart.svg
// module id = 1231
// module chunks = 4